import { Box, MenuItem, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GalleryWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '0 20px 20px',
  minHeight: '78vh',
}));

export const StickyBar = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 5,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '12px',
  padding: '10px 12px',
  backgroundColor: '#FAFCFF',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
}));

export const GalleryGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
  gap: '16px',
  paddingTop: '8px',
}));

export const CardSlot = styled(Box)(() => ({
  display: 'block',
  position: 'relative',
  '& > a': { textDecoration: 'none', color: 'inherit' },
}));

export const SortSelect = styled(Select)(() => ({
  fontSize: '13px',
  minWidth: '180px',
  height: '36px',
}));

export const SortMenuItem = styled(MenuItem)(() => ({
  fontSize: '13px',
}));

export const EmptyBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '60px 20px',
  gap: '8px',
  color: '#777',
}));
